module.exports = __webpack_public_path__ + "media/images/flags/ee-91cf616b95e5ae6df531aeac87cc8427.svg";